<template>
  <div
    class="modal-overlay"
    :class="overlayClass"
    v-if="isOpen"
    @mousedown.self="onMouseDownOverlay"
    @mouseup.self="onMouseUpOverlay"
    @click.self="onOverlayClick"
  >
    <transition name="modal-fade" @after-leave="isOpen = false">
      <div
        class="modal"
        v-if="component"
        :style="{ maxWidth: modalProps.width + 'px' }"
      >
        <div class="modal-container" :class="modalProps.class">
          <div class="modal-header">
            <h2 v-if="modalProps" :style="modalTitleStyle">
              {{ modalProps.title }}
            </h2>
            <button class="modal-close" type="button" @click="destroyModal">
              <ico
                name="icoClose"
                :fill="
                  modalProps.class === 'new-landing-success'
                    ? '#A5D8FF'
                    : '#79919C'
                "
              />
            </button>
          </div>
          <div
            :class="[
              'modal-body',
              { 'no-paddings': modalProps.modalBodyNoPaddings },
              { 'custom-paddings': modalProps.modalBodyCustomPaddings },
              { 'tags-editor-padding': modalProps.modalBodyTagsEditorPadding },
            ]"
          >
            <component
              :is="component"
              :componentProps="componentProps"
            ></component>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {
      component: null,
      componentProps: null,
      modalProps: null,
      isOpen: false,
      mouseDownStartedInsideModal: false,
    };
  },
  computed: {
    overlayClass() {
      return this.modalProps?.class;
    },
    modalTitleStyle() {
      if (!this.modalProps?.title) {
        return {};
      }

      const largeSpacingTitles = ["Регистрация", "Вход в систему"];

      return largeSpacingTitles.includes(this.modalProps.title)
        ? { marginBottom: "25px" }
        : {};
    },
  },
  methods: {
    show(component, componentProps, modalProps) {
      this.isOpen = true;
      this.modalProps = modalProps;
      this.$nextTick(() => {
        this.component = component;
        this.componentProps = componentProps;
      });
    },
    destroyModal() {
      const cmpName = this.component.name;
      this.$nextTick(() => {
        if (
          cmpName === "purchasesTableCustomFilterModal" &&
          this.$tours["startTour"].isRunning &&
          this.$tours["startTour"].currentStep > 0 &&
          this.$tours["startTour"].currentStep < 6
        ) {
          this.$tours["startTour"].stop();
          this.$tours["startTour"].start();
        }
      });
      this.component = null;
      this.componentProps = null;
      this.modalProps = null;
    },
    escapeKeyListener(e) {
      if (e.key === "Escape" && this.isOpen) {
        this.destroyModal();
      }
    },
    onGlobalMouseDown(event) {
      if (!this.$el || !this.$el.querySelector) {
        this.mouseDownStartedInsideModal = false;
        return;
      }

      try {
        const modalElement = this.$el.querySelector(".modal");
        this.mouseDownStartedInsideModal =
          modalElement && modalElement.contains(event.target);
      } catch (error) {
        console.error("Error in onGlobalMouseDown:", error);
        this.mouseDownStartedInsideModal = false;
      }
    },

    onOverlayClick() {
      if (!this.mouseDownStartedInsideModal) {
        this.destroyModal();
      }
    },
  },
  created() {
    this.$modal.container = this;
    document.addEventListener("keyup", this.escapeKeyListener);
    document.addEventListener("mousedown", this.onGlobalMouseDown);
  },
  destroyed() {
    document.removeEventListener("keyup", this.escapeKeyListener);
    document.removeEventListener("mousedown", this.onGlobalMouseDown);
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";

.modal-overlay {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 110;
  width: 100%;
  height: 100%;

  &.dark {
    background-color: fade(#ffffff, 75%);

    &::-webkit-scrollbar-thumb {
      border-radius: @br;
      background-color: @bg-color-middle;
      &:hover {
        background-color: @text-color-lighter;
      }
    }
  }

  &.light {
    background-color: fade(@text-color, 80%);

    &::-webkit-scrollbar-thumb {
      border-radius: @br;
      background-color: fade(@text-color, 40%);
      &:hover {
        background-color: fade(@text-color, 50%);
      }
    }
  }

  &::-webkit-scrollbar {
    border-radius: @br;
    width: 10px;
    background-color: transparent;
  }
}

.modal {
  width: 100%;
}

.modal-container {
  margin: 0 auto;
  border-radius: @br;
  width: 100%;
  text-align: left;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.modal-close {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 24px;
  height: 24px;
}

.modal-container.dark {
  padding: 20px 24px 24px;
  background-color: @bg-color;

  .modal-header {
    margin-bottom: 24px;

    h2 {
      font-weight: 500;
      font-size: 16px;
      line-height: 1.5;
      letter-spacing: 0.3px;
      color: #ffffff;
    }
  }
}

.modal-container.light {
  padding: 0;
  background-color: #ffffff;

  .modal-header {
    border-top-left-radius: @br;
    border-top-right-radius: @br;
    padding: 18px 32px;
    background-color: @bg-color-light;

    h2 {
      font-weight: 400;
      font-size: 18px;
      line-height: 1.5;
      letter-spacing: 0.3px;
      color: @text-color-middle;
    }
  }

  .modal-body:not(.no-paddings) {
    padding: 32px 32px 24px;
  }

  .modal-body.custom-paddings {
    padding: 32px 0px 24px 0;
  }
  .modal-body.tags-editor-padding {
    padding: 8px 0 12px 0;
  }
}
.modal-container.new-landing {
  background-color: #484e55;
  padding: 20px 24px;
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
    0 12px 40px rgba(0, 0, 0, 0.35);
  .modal-header {
    h2 {
      font-family: Montserrat;
      font-weight: 600;
      font-size: 26px;
      line-height: 1;
      text-align: center;
      color: white;
      width: 100%;
      margin-bottom: 25px;
    }

    .modal-close {
      display: none;
    }
  }
}
.modal-container.new-landing-success {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: #484e55;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08),
    0 12px 40px rgba(0, 0, 0, 0.35);
  @media (max-width: 767px) {
    width: 406px;
  }
  @media (max-width: 767px) {
    width: 316px;
  }
  .modal-header {
    .modal-close {
      display: flex;
      color: #a5d8ff;
      svg {
        fill: #a5d8ff;
      }
    }
  }
}
.modal-overlay.bitrix {
  background-color: fade(@text-color, 80%);

  &::-webkit-scrollbar-thumb {
    border-radius: @br;
    background-color: fade(@text-color, 40%);

    &:hover {
      background-color: fade(@text-color, 50%);
    }
  }
}
.modal-container.bitrix {
  background-color: #ffffff;
  border-radius: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  max-height: 701px;
  overflow: hidden;
  .modal-header {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    height: 64px;
    background-color: #f4f4f6;
    padding: 0 32px;
    h2 {
      margin: 0 !important;
      color: #7d919b;
      font-family: Roboto;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
    }
    .modal-close {
      color: #7d919b;
    }
  }
  .modal-body {
    max-height: 637px;
  }
}
</style>
